export const theme = {
  token: {
    colorPrimary: '#006db7',
    colorPrimaryText: '#006db7',
    colorLink: '#006db7',
    colorInfo: '#006db7',
    colorInfoText: '#006db7',
    colorPrimaryBgHover: '#dff2f7',
    colorBgLayout: '#ffffff',
    borderRadius: 2,
    fontFamily: 'Open Sans',
  },
};
